/**
 * Devolución (HU-15411). El balance se consume vía cargos en HU-15415:
 * `amount = amountGross - amountDiscount`. Sin enum status — el "estado" es
 * derivado (`amount > 0` pendiente, `amount === 0` consumido).
 */
export interface Refund {
  id: string;
  amountGross: number | string;
  amountDiscount: number | string;
  amount: number | string;
  concept: string;
  createdById: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRefundPayload {
  amount: number;
  concept: string;
}

export enum RefundChargeType {
  Transfer = 'TRANSFER',
  Discount = 'DISCOUNT',
}

export enum BankAccountType {
  Corriente = 'CORRIENTE',
  Vista = 'VISTA',
  Ahorro = 'AHORRO',
}

export interface RefundCharge {
  id: string;
  refundId: string;
  type: RefundChargeType;
  totalAmount: number | string;
  attachmentUrl: string | null;
  createdById: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTransferChargePayload {
  type: RefundChargeType.Transfer;
  totalAmount: number;
  // HU-15677 — preferido. FK al FileRequired temp del comprobante; el backend
  // lo promueve a permanente y regenera la URL on-demand. El frontend solo
  // necesita pasar el id que devuelve el AzureFilesUploader.
  attachmentFileId?: number | null;
  /** @deprecated HU-15677 — usar attachmentFileId. Solo para clientes legacy. */
  attachmentUrl?: string | null;
  bankHolderName: string;
  bankName: string;
  bankAccountType: BankAccountType;
  bankAccountNumber: string;
  bankContactEmail?: string | null;
}

export interface CreateDiscountChargePayload {
  type: RefundChargeType.Discount;
  totalAmount: number;
  // HU-15677 — ver nota en CreateTransferChargePayload.
  attachmentFileId?: number | null;
  /** @deprecated HU-15677 — usar attachmentFileId. */
  attachmentUrl?: string | null;
  allocations: Array<{
    debtId: string;
    amount: number;
  }>;
}

export type CreateRefundChargePayload =
  | CreateTransferChargePayload
  | CreateDiscountChargePayload;

export interface EligibleDebt {
  id: string;
  index: number;
  description: string;
  startDate: string | null;
  endDate: string;
  amountBase: number | string;
  amountPenalties: number | string;
  amountRefund: number | string;
  amount: number | string;
}
